export const baseUrl = "https://jsonplaceholder.typicode.com";
// export const BASE_URL_STAGING = "http://api.fatash.trangotechdevs.com:3035/api"
// export const BASE_URL_STAGINGHTTP = "https://api.fatash.trangotechdevs.com/api"
export const BASE_URL_STAGINGHTTP = "https://api.fatashhealthcare1.com/api"
export const CHAT_PORTURL = 'https://api.fatashhealthcare1.com'
export const INITIAL_TOKEN = "1e4ad4bf-d6fe-4db7-87e1-c78b6834a7a5"
